import { isNumberMapAttributeKeyDefinitionOfType, isValidAttributeKeyDefinitionOfType, } from '@iotv/iotv-v3-types';
import { useMemo } from 'react';
import { BinaryControl } from './BinaryControl';
import { getBitMapControlFC } from './BitMapControl';
import { FlatMapControl } from './FlatMapControl';
import { NumericControl } from './NumericControl';
import { UnknownAttributeControl } from './UnknownAttributeControl';
export const useArbitrator = ({ requiredKeys, rangeLimits }) => {
    const { resolvedControls, unresolvedControls } = useMemo(() => rangeLimits
        ? requiredKeys.reduce((acc, key) => {
            const ControlComponent = resolveControlType(key, rangeLimits);
            if (ControlComponent === UnknownAttributeControl) {
                acc.unresolvedControls[key] = ControlComponent;
            }
            else {
                acc.resolvedControls[key] = ControlComponent;
            }
            return acc;
        }, { resolvedControls: {}, unresolvedControls: {} })
        : { resolvedControls: {}, unresolvedControls: {} }, [requiredKeys, rangeLimits]);
    return { resolvedControls, unresolvedControls };
};
const resolveControlType = (key, rangeLimits) => {
    const attributeValidation = rangeLimits?.[key];
    if (!attributeValidation) {
        return UnknownAttributeControl;
    }
    if (isValidAttributeKeyDefinitionOfType(attributeValidation, 'boolean')) {
        return BinaryControl;
    }
    else if (isValidAttributeKeyDefinitionOfType(attributeValidation, 'number')) {
        return NumericControl;
    }
    // else if (isValidAttributeKeyDefinitionOfType(attributeValidation, 'bitmap') ) {
    //     return OptionsBitMapControl
    // }
    else if (isNumberMapAttributeKeyDefinitionOfType(attributeValidation)) {
        return FlatMapControl;
    }
    else if (isValidAttributeKeyDefinitionOfType(attributeValidation, 'array')) {
        return FlatMapControl;
    }
    else if (isValidAttributeKeyDefinitionOfType(attributeValidation, 'present')) {
        return BinaryControl;
    }
    else if (isValidAttributeKeyDefinitionOfType(attributeValidation, 'bitmap')) {
        const bitMap = Object.fromEntries(Object.entries(attributeValidation.bitmap).map(([k, v]) => [k, !v ? 0 : 1]));
        return getBitMapControlFC(bitMap);
    }
    else {
        return UnknownAttributeControl;
    }
};
